import React from 'react';
import { sanitizeIntegerDigits, parsePositiveInt } from '../utils/integerInput';

/**
 * Yalnızca tam sayı girişi (text + inputMode numeric). Adet alanları için.
 */
const IntegerInput = ({
  value,
  onChange,
  onBlur,
  min = 1,
  max,
  allowEmpty = false,
  className = '',
  style,
  disabled,
  autoFocus,
  id,
  name,
  placeholder,
  'aria-label': ariaLabel,
  title,
}) => {
  const displayValue =
    value === null || value === undefined ? '' : String(value);

  const handleChange = (e) => {
    let next = sanitizeIntegerDigits(e.target.value, { allowEmpty });
    if (next !== '' && max != null) {
      const n = parseInt(next, 10);
      if (Number.isFinite(n) && n > max) {
        next = String(max);
      }
    }
    onChange?.(next);
  };

  const handleBlur = (e) => {
    let next = displayValue;
    if (!allowEmpty || next !== '') {
      next = String(parsePositiveInt(next, { min, max, fallback: min }));
    }
    if (next !== displayValue) {
      onChange?.(next);
    }
    onBlur?.(e);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      id={id}
      name={name}
      className={className}
      style={style}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      autoFocus={autoFocus}
      placeholder={placeholder}
      aria-label={ariaLabel}
      title={title}
    />
  );
};

export default IntegerInput;
